import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@4.3.0@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-huandian",
  "use": "icon-huandian-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-huandian\"><path d=\"M858 703.21l-94.38-15.36 22.13-156.43a31 31 0 0 0-54.86-23.83L532.78 753.22a31 31 0 0 0 16.4 49.51L651 829l-19.4 160.08a31 31 0 0 0 55.77 22.11L878 752.21a31 31 0 0 0-20-49z m-150.66 176.2l8.47-70a31 31 0 0 0-23.05-33.76l-81.44-21 97.29-120.6-10.61 75.2a31 31 0 0 0 25.73 35L798 756.3z\" /><path d=\"M852.16 122.52H696.38V31.19a31 31 0 0 0-31-31H358.64a31 31 0 0 0-31 31v91.33h-155.8c-32.43 0-58.8 28-58.8 62.51V956.4c0 34.47 26.37 62.51 58.8 62.51h269.68a31 31 0 0 0 0-62H175.1V185v-0.47h673.8V525.49a31 31 0 1 0 62 0L911 185c0-34.44-26.41-62.48-58.84-62.48z m-462.5-60.31h244.68v60.31H389.66z\" /><path d=\"M300.16 385.15h399.43a31 31 0 0 0 0-62H300.16a31 31 0 1 0 0 62zM300.16 589.25h288.65a31 31 0 0 0 0-62H300.16a31 31 0 0 0 0 62z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/huandian.svg
// module id = 9mxA
// module chunks = 143